import { j as json } from "../../../../chunks/index2.js";
import { randomUUID } from "crypto";
import admin from "firebase-admin";
import { s as stripe } from "../../../../chunks/stripe.js";
import { c as sendLicenseEmail } from "../../../../chunks/mailer.js";
const generateLicenseAndNotifyUser = async (paymentIntent) => {
  const license = randomUUID().toUpperCase();
  const customer = await stripe.customers.retrieve(paymentIntent.customer);
  if (customer.deleted || !customer.email) return null;
  await admin.firestore().collection("licenses").doc(customer.email).set({
    code: license
  });
  await sendLicenseEmail(customer.email, license);
};
const POST = async ({ request }) => {
  const body = await request.json();
  const type = body.type;
  if (type === "payment_intent.succeeded") {
    await generateLicenseAndNotifyUser(body.data.object);
  }
  return json({
    received: true
  });
};
export {
  POST
};
